import { useAppLanguage } from "src/shared/ui/src/contexts/LanguageContext";

/** Use the same reactive language and dictionary as the rest of the application. */
export function useShowcaseLanguage() {
  const { language, setLanguage, dico } = useAppLanguage();
  const t = (key: string) => dico.showcase[key] ?? key;
  const assetBase = language === "en" ? "/showcase/en/" : "/showcase/";
  return { language, setLanguage, t, assetBase, translations: dico.showcase };
}
